module.exports = __webpack_public_path__ + "img/excavator.1cd4746.png";